<template>
    <b-form-select :input="input" v-on="$listeners" :options="customCertsList" />
</template>

<script>
import { getUserCertificates } from "crypto-pro";
import format from "date-fns/format"

export default {
    name: "EcpSelect",
    props: {
        input: {
            type: Object,
            default: () => null,
        },
    },
    data() {
        return {
            certsList: [],
        };
    },
    computed: {
        customCertsList() {
            if (!Array.isArray(this.certsList)) return [];

            return this.certsList.map(cert => ({
                text: cert.name + ' (действителен до: ' + format(new Date(cert.validTo), 'dd.MM.yyyy HH:mm')  + ')',
                value: cert,
            }));
        },
    },
    created() {
        getUserCertificates().then(list => {
            this.certsList = list;
        });
    },
};
</script>
